import { ReactNode } from "react";

interface BulletedTextListDescriptionProps {
  description: string | ReactNode;
  variant: "default" | "small";
}

export default function BulletedTextListDescription({
  description,
  variant,
}: BulletedTextListDescriptionProps) {
  return (
    <div
      className={`${variant === "default" ? "elm-p4 leading-learn-hero-line-height" : "text-base"} mt-5 `}
    >
      {typeof description === "string" ? <p>{description}</p> : description}
    </div>
  );
}
